import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { ShelterAppStateModel } from "./store/ShelterAppStateModel";
import { Store } from "@ngrx/store";
import * as AuthActions from './store/auth/auth.actions';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Petszel Connect Organization';
  lastTrackedPage = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<ShelterAppStateModel>
  ) {
    // Track page views only when the route changes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.lastTrackedPage !== event.urlAfterRedirects) {
          this.lastTrackedPage = event.urlAfterRedirects;

          gtag('config', 'G-SKMZZ8V587', { page_path: this.lastTrackedPage });
        }
      }
    });
  }

  ngOnInit() {
    this.store.dispatch(AuthActions.hydrateAuth());

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route: any) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter((route: any) => route.outlet === 'primary'))
      .pipe(mergeMap((route: any) => route.data))
      .subscribe((event: any) => this.updateBodyClass(event.bodyClass));
  }

  private updateBodyClass(customBodyClass?: string) {
    this.renderer.setAttribute(this.document?.body, 'class', '');
    if (customBodyClass) {
      this.renderer.addClass(this.document?.body, customBodyClass);
    }
  }
}
